import React, { useCallback, useEffect, useMemo, useState } from 'react'
import animationData from 'assets/lotties/car-loading-animation.json'
import { useLottie } from 'lottie-react'

interface Props {
  overrideTitle?: string | React.ReactElement
}

const AppLoadingIndicator = ({ overrideTitle }: Props) => {
  const [textIndex, setTextIndex] = useState(0)
  const loadingText = [
    'Loading...',
    'Fueling our engines...',
    'A few more seconds...'
  ]

  const defaultOptions = useMemo(
    () => ({
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      },
      style: {
        height: 150,
        width: 300,
        margin: '0 auto'
      }
    }),
    []
  )

  const { View } = useLottie(defaultOptions)

  const incrementIndex = useCallback((currentIndex: number) => {
    if (currentIndex === 2) {
      setTextIndex(0)
      return false
    }
    setTextIndex(currentIndex + 1)
  }, [])

  useEffect(() => {
    const textInterval = setInterval(() => incrementIndex(textIndex), 3000)
    return () => clearInterval(textInterval)
  }, [textIndex, incrementIndex])

  return (
    <div className="grid place-content-center h-[80vh]">
      {View}
      <h2 className="text-center">{overrideTitle || loadingText[textIndex]}</h2>
    </div>
  )
}

export default AppLoadingIndicator
